import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@material-ui/core";

interface IProps {
	title: string;
	content: Array<string>;
	isOpen: boolean | undefined;
}

export const LyfeDialog: React.FC<IProps> = ({ title, content, isOpen, children }) => {
	return (
		<Dialog disableBackdropClick disableEscapeKeyDown maxWidth="xs" aria-labelledby="confirmation-dialog-title" open={!!isOpen}>
			<DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
			<DialogContent dividers>
				{content.map((line, index) => (
					<Typography key={index} variant="subtitle1">
						{line}
					</Typography>
				))}
			</DialogContent>
			<DialogActions>{children}</DialogActions>
		</Dialog>
	);
};
